import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { NumberPipe } from '@progress/kendo-angular-intl';
import { ModalAdminTiendaEditarProductos } from '../../AdministrarTienda/Productos/ModalAdminTiendaEditarProductos/ModalAdminTiendaEditarProductos.component';
import Swal from 'sweetalert2';
import { AuthService } from "../../services/auth.service";
import { ProductoService } from "../../services/producto.service";
import { CategoriasService } from "../../services/categorias.service";
import { splitBlock } from '@angular/localize/src/utils';
import { ColaboradoresService } from '../../services/colaboradores.service';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'ho1a-Admin-Productos',
    templateUrl: './Productos.component.html',
    styleUrls: ['./Productos.component.scss']
})
export class AdminTiendProductosComponent implements OnInit {

    loading: boolean = true;
    gridData: any = [];
    categorias: any = [];
    filespath = environment.filespath;
    productoResult: boolean = true;
    idEmpleadoLogeado: any;
    activo: Boolean;
    error: string;
    company: any = {
      color: '',
      isoLogo: '',
      logo: '',
      name: '',
      prefix: '',
      id: ''
    };
    cId: any;

    constructor(
        private productoService: ProductoService,
        private categoriasService: CategoriasService,
        private authService: AuthService,
        public dialog: MatDialog,
        private colaboradorService: ColaboradoresService,
    ) {
        const user = this.authService.getCookieUser();
        this.idEmpleadoLogeado = user.Id;
        this.activo = true;
        this.cId = localStorage.getItem('id_compania');
        this.allData = this.allData.bind(this);

    }
    ngOnInit() {
      this.productoService.getProductos(this.cId).subscribe(resp => {
            this.gridData = resp;
            this.loading = false;
        }, error => this.error = error,
            () => { }
        );
        this.obtenerCategorias();
    }

    obtenerCategorias() {
      this.categoriasService.getCategorias(this.cId).subscribe(resp => {
            this.categorias = resp;
        }, error => this.error = error,
            () => { }
        );
    }

    abrirEditar(nombre, descripcion, costo, stock, categoriaId, imagen, id, notas) {
        const dialogRef = this.dialog.open(ModalAdminTiendaEditarProductos, {
            width: '800px',
            data: {
                nombre: nombre,
                descripcion: descripcion,
                costo: costo,
                stock: stock,
                categoria_id: categoriaId,
                img: imagen,
                id: id,
                tipo: 1,
                categorias: this.categorias,
                notas: notas
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.loading = true;
            this.refresh();
        });
    }

    refresh() {
        this.activo = true;
        this.loading = true;
        this.productoService.getProductos(this.cId).subscribe(resp => {
            this.gridData = resp;
            this.loading = false;
        }, error => this.error = error,
            () => { }
        );
    }

    public allData(): ExcelExportData {
        const result: ExcelExportData = {
            data: this.gridData
        };
        return result;
    }

    abrirNuevo() {
        const dialogRef = this.dialog.open(ModalAdminTiendaEditarProductos, {
            width: '800px',
            data: {
                nombre: '',
                descripcion: '',
                costo: '',
                stock: '',
                categoria_id: '',
                img: '',
                id: '',
                tipo: 2,
                categorias: this.categorias,
                notas: ''
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            // console.log('The dialog was closed');
            this.loading = true;
            this.refresh();
        });
    }

    borrarProducto(ID: number) {
        Swal.fire({
            title: '¿Está seguro de continuar con la eliminación?',
            text: '¡La información del producto no podrá ser recuperada!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, ¡bórralo!',
            cancelButtonText: 'No, mantenerlo'
        }).then((result) => {
            if (result.value) {
                this.EliminarProducto(ID);
                Swal.fire(
                    '¡Eliminado!',
                    'El producto se eliminó correctamente',
                    'success'
                )
                this.ngOnInit();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                this.loading = false;
                Swal.close();
            }
        })
    }

    EliminarProducto(ID: number) {
        this.loading = true;
        this.productoService.deleteProductos(ID)
            .subscribe(
                (val) => {
                    this.productoResult = val;
                    if (val) {
                        this.ngOnInit();
                    }
                    this.loading = false;
                }, response => {
                    this.loading = false;
                    Swal.fire({ icon: 'error', title: 'Ocurrió un error', text: 'Contacte al administrador' });
                });
    }
}
